var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{on:{"click":_vm.downloadToCsv}},[_vm._v(" "+_vm._s(_vm.$t('csv.exportCsv'))+" "),_c('v-icon',{attrs:{"right":""}},[_vm._v(" mdi-cloud-download ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }